import dayjs, {Dayjs} from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const toDate = (date: string) => {
  const [day, month, year] = date.split('/');
  return dayjs(`${year}-${month}-${day}`).toDate();
};

/**
 * ajout annee pour format : YYYY-YYYY
 */
export const ajouterAnnee = (chaine: string) =>
  chaine.replace(/(\d{4})-(\d{4})/, (_, a1, a2) => `${+a1 + 1}-${+a2 + 1}`);

/**
 * compare et retourne la date maximal
 */
export const maxDate = (date1: Dayjs, date2: Dayjs): Dayjs => {
  return date1.isAfter(date2) ? date1 : date2;
};

/**
 * retourne une date d' effet valide pour le renouvellement
 */
export const nextDateEffect = (dateEcheance: string) => {
  return maxDate(dayjs(toDate(dateEcheance)).add(1, 'day'), dayjs()).format(
    'DD/MM/YYYY',
  );
};

export const getNextDay = (date: Date): Date => {
  const nextDay = dayjs(date).add(1, 'day').toDate();
  return nextDay;
};

export const handleDateValue = (dateString: string) => {
  let date = new Date();
  const dateRegex =
    /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;
  if (!dateRegex.test(dateString)) {
    const tempDate = new Date(dateString);
    if (tempDate.toString() !== 'Invalid Date') {
      date = new Date(dateString);
    }
  } else {
    const dateParts = dateString.split('/');
    date.setUTCDate(parseInt(dateParts[0]));
    date.setUTCMonth(parseInt(dateParts[1]) - 1);
    date.setUTCFullYear(parseInt(dateParts[2]));
  }
  return date;
};
